import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCartData } from './CartDataContext';

export default function PathnameBridge() {
  const location = useLocation();
  const { setPathname } = useCartData();

  useEffect(() => {
    setPathname(location.pathname);
  }, [location.pathname, setPathname]); // ✅ use pathname, not location

  return null;
}
